import { useState, useEffect } from 'react';
import { BREAKPOINTS } from '../constants/breakpoints';

export const useIsMobile = (breakpoint = BREAKPOINTS.md) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};
